var _excluded = ["src", "title", "width", "isCmpLazyLoad"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
var StyledIframeAtm = styled.iframe.withConfig({
  componentId: "sc-1ijp0so-0"
})(function (_ref) {
  var $width = _ref.$width;
  return css(["width:", ";max-width:100%;aspect-ratio:16 / 9;"], $width ? "".concat($width, "px") : "936px");
});
function IframeAtm(_ref2) {
  var src = _ref2.src,
    title = _ref2.title,
    width = _ref2.width,
    isCmpLazyLoad = _ref2.isCmpLazyLoad,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledIframeAtm, _extends({
    src: src,
    title: title,
    $width: width,
    className: isCmpLazyLoad ? "cmplazyload" : undefined
  }, restProps));
}
export default IframeAtm;